import {
  AutoComplete,
  Input,
  Tooltip,
  Breadcrumb,
  message,
  Select,
} from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import {
  EditIcon,
  DeleteIcon,
  DetailIcon,
  SearchIcon,
  AscRed,
  DescGrey,
  CloseIconSearch,
} from "../../../asset";
import style from "./CustomerList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import { useDispatch, useSelector } from "react-redux";
import { GROLOG_URL } from "../../../constant/apiConstant";
import CustomPaging from "../../../component/pagination/pagination";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { onChanged, permissionButton } from "../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../component/select/SelectOption";

const CustomerList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [filter, setFilter] = useState();
  const [load, setLoad] = useState(false);
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState();
  const [isFilter, setIsfilter] = useState(false);
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const dispatch = useDispatch()
  const { permission } = useSelector((state) => state.auth);


  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGet(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}

  const fetchData = async (data, sort, pages) => {
    console.log("depot", depot);
    setLoad(true);
    let res2 = await doGet(
      `/depot-list-filter?page=1&limit=10&${param}`,
      token
    );
    if(!res2?.data?.payload?.data){
      setLoad(false)
    }else{
    let res = await doGet(
      `/customer?page=${pages ? pages : page}&limit=${limit}&order=id ${
        sort ? sort : sorting
      }&filter=depot_id eq ${depot ? depot : res2?.data?.payload?.data[0]?.depot_id}${
        filter
          ? ", customer_name lk " + filter
          : data
          ? ", customer_name lk " + data
          : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/customer/initiate?page=${
        pages ? pages : page
      }&limit=${limit}&order=id ${sort ? sort : sorting}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${
        filter
          ? ", customer_name lk " + filter
          : data
          ? ", customer_name lk " + data
          : ""
      }&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
      setDropdown(selectOption(currentDepot, option, "value"));
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setListData(res?.data?.payload?.data);
    if (init?.data?.payload?.data) {
      setInitiate(init?.data?.payload?.data);
    }
    setLoad(false);
  }
  };

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page, limit, depot,depotName, filter]);

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      console.log("sini g");
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleEdit = (id) => {
    navigate(ROUTES.CUSTOMER.EDIT, { state: id });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.CUSTOMER.DETAIL, { state: id });
  };

  const handleAdd = (id) => {
    navigate(ROUTES.CUSTOMER.ADD, { state: depot ? depot : depot1 });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const doSort = async (sort) => {
    setSorting(sort);
    if (sort) {
      setSorting(sort);
      fetchData("", sort);
    }
  };

  const dataSource = listData
    ? listData.map((result) => ({
        customerId: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.customer_id}
          </span>
        ),
        firstName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.first_name}
          </span>
        ),
        lastName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.last_name}
          </span>
        ),
        mobilePhone: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.phone}
          </span>
        ),
        fax: (
          <span className="font-roboto text-lg text-[#222222]">
            {result.fax}
          </span>
        ),
        email: (
          <span className="font-roboto text-lg text-[#222222] w-28 max-w-xs">
            {result?.email}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip className={
          permissionButton(permission, "update", "customer", "master")
            ? ""
            : "hidden"
        }  title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.customer_id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip>
            <Tooltip className={
          permissionButton(permission, "delete", "customer", "master")
            ? ""
            : "hidden"
        } title={t("Delete")} color="#CF0000">
              <button onClick={() => setModal(result)}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.customer_id, result?.updated_at)}
                onClick={() => handleDetail(result?.customer_id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Customer ID")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={
                    sorting === "asc"
                      ? "w-full cursor-pointer"
                      : "rotate-180 w-full cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={
                    sorting === "asc"
                      ? "w-full cursor-pointer"
                      : "rotate-180 w-full cursor-pointer mt-1"
                  }
                  onClick={() => {
                    doSort("desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "customerId",
      key: "customerId",
      render: (customerId) => <span>{customerId}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:FIRST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName) => <span>{firstName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:LAST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "lastName",
      key: "lastName",
      render: (lastName) => <span>{lastName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Phone")}
        </span>
      ),
      dataIndex: "mobilePhone",
      key: "mobilePhone",
      render: (mobilePhone) => <span>{mobilePhone}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Fax")}
        </span>
      ),
      dataIndex: "fax",
      key: "fax",
      render: (fax) => <span>{fax}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("E-mail")}
        </span>
      ),
      dataIndex: "email",
      key: "email",
      render: (email) => <span>{email}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
        let res = await doGet(
        `/customer/search?page=1&limit=10&filter=depot_id eq ${
          depot ? depot : depot1
        }, customer_name lk ${filters}&${param}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const handleChange = (value, id) => {
    console.log("value", value);
    setDepot(value);
    setDepotName(value);
    fetchData();
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true);
    setSearchRecommedation(value);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data);
    fetchData(data, sorting, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("", sorting, 1);
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.customer_id}
        delete={showDelete}
        title={data.first_name}
        url={"customer"}
        action={() => setShowDelete(false)}
        route={ROUTES.CUSTOMER.LIST}
        refresh={() => fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={2}
          menuLevel1={`Master`}
          menuLevel2={`Customer`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("Customer")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex">
            <AutoComplete
              options={options}
              value={searchRecommendation}
              onChange={(value) => onSearchRecommendation(value)}
              onSelect={(value) => onSelectRecommendation(value)}
            >
              <Input
                placeholder={t("Search Customer Name")}
                suffix={
                  <img
                    src={filter ? CloseIconSearch : SearchIcon}
                    alt="search"
                    onClick={filter ? () => onClearRecommendation() : null}
                  />
                }
                // options={options}
                value={searchRecommendation}
                // onChange={(value) => onSearchRecommendation(value)}
                height={47}
                width={350}
                className="w-[350px] h-[47px]"
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[200px]"}
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
            >
              {!loading
                  ? dropdown
                  : [...dropdown, LoadingOption()]}
              </Select>
          </div>

            <PrimaryButton
            actions="insert"
            menu="customer"
            parent="master"
              text={t("Add Customer")}
              action={() => handleAdd()}
              disabled={dropdown?.length===0 || load}
              // action={()=>navigate(ROUTES.CUSTOMER.ADD, { state: depot ? depot : depot1 })}
              prefixIcon={<AddIcon />}
            />
        </div>
        {!load ? (
          <div className={style.tableContainer}>
            <CustomTable columns={ListColumn} data={dataSource} />
            <div className={style.containerPagination + " mt-[-45px]"}>
              <CustomPaging
                idLimit="ddlrowsperpagemustselllist"
                idPagination="btnpaginationmustselllist"
                size="small"
                current={page}
                defaultCurrent={page}
                pageSize={limit}
                total={initiate && initiate?.count_data}
                pageSizeOptions={initiate && initiate?.valid_limit}
                onShowSizeChange={() => handlePagination()}
                handlePaging={(a, b) => handlePagination(a, b)}
                title={t("COMMON:ROW_PAGE")}
              />
            </div>
          </div>
        ) : (
          "...loading"
        )}
      </div>
    </>
  );
};

export default CustomerList;
